import React from "react";
import foto from "../../images/Calendario Cigno 20232024.jpg"
import FrecciaIndietro from "../../commons/FrecciaIndietro";
import Space from "../../commons/Space";
import locandina from "../../images/PreIscrizioni/A3.png"
import TitoloSezioni from "../../commons/TitoloSezioni";
import "./NewsPagesFoto.css"
import ScrollToTopOnMount from "../../components/ScrollToTopOnMount";


function NuoviCorsi () {
    return(
        <div className="text-center">
            <ScrollToTopOnMount />
            <FrecciaIndietro indirizzo={"/news"} />
            <p className="text-center" style={{ fontSize: "22px", fontFamily: "Hammersmith One" }}>{"17.06.2024"}</p>
            <div className="container-foto-news m-auto" style={{display: "flex", flexDirection: "column"}}>
                <img src={locandina} style={{width: "100%"}}></img>
            </div>
            <Space />

        </div>
    )
}
export default NuoviCorsi